<template>
  <div>
    <el-table :data="data" :span-method="arraySpanMethodGx" border>
      <el-table-column type="index" width="50"> </el-table-column>
      <el-table-column label="日期" prop="classTime"> </el-table-column>
      <el-table-column label="课程名称" prop="courseName"> </el-table-column>
      <el-table-column label="地点" prop="addressName"> </el-table-column>
      <el-table-column label="课时" prop="hour"> </el-table-column>
      <el-table-column label="签到信息">
        <template v-slot="scope">
          <el-image v-if="scope.row.sign !== '未签到'" style="width: 40px; height: 30px; line-height: 30px" fit="contain"
            align="center" :src="scope.row.sign" :preview-src-list="[scope.row.sign]">
          </el-image>
          <el-image v-if="scope.row.signature !== ''" style="width: 40px; height: 30px; line-height: 30px"
            align="center" :src="scope.row.signature" :preview-src-list="[scope.row.signature]" alt="111">
          </el-image>
          <span v-if="scope.row.sign === '' ? (scope.row.signature === '' ? true : false) : false">---</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { lineStu } from '@/api';
export default {
  props: {
    msg: String,
  },
  data () {
    return {
      data: [],
      imgBaseUrl: 'https://qingjuck.oss-cn-shanghai.aliyuncs.com/',
    };
  },
  methods: {
    getTableDataGx () {
      let spanOneArr = [];
      let spanTwoArr = [];
      let concatOne = 0;
      let concatTwo = 0;
      this.data.forEach((item, index) => {
        if (index === 0) {
          spanOneArr.push(1);
          spanTwoArr.push(1);
        } else {
          if (item.classTime === this.data[index - 1].classTime) {
            spanOneArr[concatOne] += 1;
            spanOneArr.push(0);
          } else {
            spanOneArr.push(1);
            concatOne = index;
          }
        }
      });
      return {
        one: spanOneArr,
        two: spanTwoArr,
      };
    },
    //  表格合并
    arraySpanMethodGx ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        const _row = this.getTableDataGx(this.JZPFDataGx).one[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
  mounted () {
    lineStu({ stuId: this.msg }).then(res => {
      this.data = res;
      //  签到图片拼接
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].sign !== '未签到') {
          this.data[i].sign = this.imgBaseUrl + this.data[i].sign;
        }
        if (this.data[i].signature !== '') {
          this.data[i].signature = this.imgBaseUrl + this.data[i].signature;
        }
      }
    });
  },
};
</script>
